export default __webpack_public_path__ + "static/media/hero_image_updated.fdc85086.png";